module.exports = __webpack_public_path__ + "img/eyes.a11e4654.png";